<script>
  import ActionButton from "./ActionButton.svelte";
  import { PlayerId, PlayersStore, SelectedActions } from "../stores/gameStore";

  export let stacked;

  $: color = "#" + $PlayersStore[$PlayerId]?.color;
  $: actions = $SelectedActions;

  const textTurnOrder = _('Turn Order');
</script>


<div
class="wrapper"
class:stacked={stacked}
>
  <div style:font-weight={600}>{textTurnOrder}</div>
  <div class="buttons">
    {#each actions as { playerId, action }, i}
      <ActionButton
        width={50}
        color={"#" + $PlayersStore[playerId]?.color}
        type={action}
      />
    {/each}
  </div>
</div>

<style>
  .wrapper {
    display: flex;
    gap: 0.25rem;
    flex-direction: column;
    align-items: flex-end;
  }

  .wrapper.stacked {
    align-items: center;
  }

  .buttons {
    display: flex;
    gap: 0.5rem;
  }
</style>
